import { environment } from '@env/environment';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'iw-numeric-decimal',
  templateUrl: './numeric-decimal.component.html',
  styleUrls: ['./numeric-decimal.component.scss']
})
export class NumericDecimalComponent implements OnInit {

  // Para mostrar información de debug.
  @Input() debug: boolean = environment.showDebugHelpers;
  // Formulario
  form: FormGroup = new FormGroup({
    num1: new FormControl(''),
    num2: new FormControl('')
  });

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/examples/numeric-decimal/numeric-decimal.component.ts